<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="lg"
    scrollable
    no-close-on-backdrop
  >
    <b-row class="modal-trabajo-adicional">
      <!-- Employee -->
      <b-col cols="12" v-if="mostrarEmpleados">
        <b-form-group label-for="employee_id">
          <label class="form-label"
            >{{ $t("Employee") }} <span class="text-danger">(*)</span></label
          >
          <v-select
            id="employee_id"
            v-model="form.employee_id"
            :options="employees"
            label="label"
            :reduce="(dt) => dt.id"
          />
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <div class="d-flex justify-content-center align-items-center">
          <vc-date-picker
            id="fecha-trabajo"
            class="d-inline-block w-100"
            v-model="form.fecha"
            :is-dark="isDarkSkin"
            :model-config="{
              type: 'string',
              timeZone: 'America/Lima',
              mask: 'YYYY-MM-DD',
            }"
            :min-date="minDate"
            :max-date="maxDate"
            :attributes="highlightedDates"
          />
        </div>
        <!-- </b-form-group> -->
      </b-col>

      <b-col cols="6">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Descripción del trabajo realizado:"
              label-for="descripcion-trabajo"
            >
              <b-form-textarea
                id="descripcion-trabajo"
                v-model="form.descripcion"
                placeholder="Ejemplo: Se realizaron trabajos adicionales: ajuste de cableado, revisión de equipos y validación de operación completa."
                rows="1"
                class="w-100"
                :disabled="isProcesar"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group
              label="Adjuntar archivo (opcional):"
              label-for="archivo-trabajo"
            >
              <b-form-file
                v-if="!form.archivoUrl"
                id="archivo-trabajo"
                v-model="form.archivo"
                placeholder="Seleccione un archivo..."
                drop-placeholder="Suelte el archivo aquí..."
                browse-text="Buscar"
                class="w-100"
                :disabled="form.archivoUrl || isProcesar"
              ></b-form-file>

              <div
                v-if="form.archivoUrl"
                class="mt-1 d-flex align-items-center justify-content-between"
              >
                <b-link :href="form.archivoUrl" target="_blank">
                  <feather-icon icon="FileIcon" class="text-primary" /> Ver
                  archivo adjunto
                </b-link>
                <b-button
                  v-if="!isProcesar"
                  size="sm"
                  variant="outline-danger"
                  @click="deleteArchivoTrabajoAdicional"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="text-danger"
                  ></feather-icon>
                </b-button>
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="4" v-if="isProcesar">
            <b-form-group label-for="remunerable">
              <template #label>
                <span>Remunerable<span class="text-danger"> *</span></span>
              </template>
              <b-form-checkbox v-model="form.remunerable" switch>
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col cols="12" v-if="isProcesar">
            <b-form-group label-for="observacion">
              <template #label>
                <span>Observación<span class="text-danger"> *</span></span>
              </template>
              <b-form-textarea
                id="observacion"
                v-model="form.comentario_revisor"
                placeholder="Ejemplo: Trabajo adicional aprobado para el personal."
                rows="1"
                class="w-100"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col v-if="!isProcesar" cols="12" class="text-right">
        <b-button
          size="sm"
          variant="outline-primary"
          :disabled="
            !form.fecha ||
            !form.descripcion ||
            (mostrarEmpleados && !form.employee_id)
          "
          @click="registrarTrabajoAdicional"
        >
          {{ isEditing ? "ACTUALIZAR" : "REGISTRAR" }}
        </b-button>
      </b-col>

      <b-col v-if="isProcesar" cols="12" class="text-right">
        <b-button
          class="mr-2"
          size="sm"
          variant="outline-danger"
          @click="procesarTrabajoAdicional('anulado')"
        >
          ANULAR
        </b-button>
        <b-button
          size="sm"
          variant="outline-success"
          @click="procesarTrabajoAdicional('aprobado')"
        >
          CONFIRMAR
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import TrabajoAdicionalService from "@/views/rrhh/views/trabajo-adicional/services/trabajo.adicional.service.js";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import UserServices from "@/views/users/services/users.service";

export default {
  components: {
    ToastificationContent,
    FeatherIcon,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    procesar: {
      type: Boolean,
      default: false,
    },
    mostrarEmpleados: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: true,
      form: {
        fecha: null,
        descripcion: "",
        archivo: null,
        archivoUrl: null,
        employee_id: null,
      },
      employees: [],
    };
  },
  computed: {
    isEditing() {
      return this.id !== null;
    },
    isProcesar() {
      return this.procesar;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    title() {
      if (this.isProcesar) {
        return "PROCESAR TRABAJO ADICIONAL";
      }

      return this.isEditing
        ? "EDITAR TRABAJO ADICIONAL"
        : "REGISTRAR TRABAJO ADICIONAL";
    },
    minDate() {
      if (this.isEditing || this.isProcesar) {
        const min = new Date(this.form.fecha);
        min.setDate(min.getDate() + 1);
        return min;
      } else {
        const min = new Date();
        min.setDate(min.getDate() - 7);
        return min;
      }
    },
    maxDate() {
      if (this.isEditing || this.isProcesar) {
        const max = new Date();
        max.setDate(max.getDate());
        return max;
      } else {
        const max = new Date();
        max.setDate(max.getDate() + 7);
        return max;
      }
    },
    highlightedDates() {
      return [
        {
          dot: this.isEditing || this.isProcesar ? false : true,
          highlight: this.isEditing || this.isProcesar ? true : false,
          dates:
            this.isEditing || this.isProcesar
              ? moment.tz(this.form.fecha, "America/Lima").toDate()
              : moment.tz(new Date(), "America/Lima").toDate(),
        },
      ];
    },
  },
  mounted() {
    if (this.isEditing || this.isProcesar) {
      this.getTrabajoAdicionalPorId();
    }

    if (this.mostrarEmpleados) {
      this.getEmployees();
    }
  },
  methods: {
    async getEmployees() {
      try {
        const { data } = await UserServices.getPersonals();
        this.employees = data;
      } catch (error) {
        console.log(error);
      }
    },
    async registrarTrabajoAdicional() {
      try {
        const { isConfirmed } = await this.showConfirmSwal();
        if (!isConfirmed) {
          return;
        }
        this.addPreloader();

        let formData = new FormData();

        let id_personal = this.mostrarEmpleados
          ? this.form.employee_id
          : this.currentUser.employee_id;

        formData.append("fecha", this.form.fecha);
        formData.append("descripcion", this.form.descripcion);
        formData.append("id_personal", id_personal);

        if (this.form.archivo) {
          formData.append("archivo", this.form.archivo);
        }

        if (this.isEditing) {
          formData.append("id", this.id);
        }

        const { data } = await TrabajoAdicionalService.store(formData);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        if (this.mostrarEmpleados) {
          this.$emit("created");
        }
        if (this.isEditing) {
          this.$emit("update", data.data);
        } else {
          this.$emit("close", data.data);
        }
      } catch (error) {
        console.error(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XIcon",
            variant: "danger",
            text: "Error al programar las vacaciones.",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async procesarTrabajoAdicional(estado) {
      try {
        const { isConfirmed } = await this.showConfirmSwal();
        if (!isConfirmed) {
          return;
        }
        this.addPreloader();

        let params = {
          comentario_revisor: this.form.comentario_revisor,
          revisor_id: this.currentUser.id,
          id: this.id,
          estado: estado,
          remunerable: this.form.remunerable ? 1 : 0,
        };

        const { data } = await TrabajoAdicionalService.update(params);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        this.$emit("update", data.data);
      } catch (error) {
        console.error(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XIcon",
            variant: "danger",
            text: "Error al procesar el trabajo adicional.",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async getTrabajoAdicionalPorId() {
      try {
        const { data } = await TrabajoAdicionalService.getTrabajoAdicionalPorId(
          {
            id: this.id,
          }
        );
        this.form.fecha = data.fecha;
        this.form.descripcion = data.descripcion;
        this.form.archivoUrl = data.archivo;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
    async deleteArchivoTrabajoAdicional() {
      try {
        const { isConfirmed } = await this.showConfirmSwal();

        if (!isConfirmed) {
          return;
        }
        this.addPreloader();

        const { data } =
          await TrabajoAdicionalService.deleteArchivoTrabajoAdicional({
            id: this.id,
          });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });

        this.form.archivoUrl = null;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
.modal-trabajo-adicional {
  .custom-dark {
    background-color: #111113 !important;
  }

  .custom-light {
    background-color: #f8f9fa !important;
  }

  .card .card-title {
    margin-bottom: 0.5rem;
  }
}
</style>